module.exports = __webpack_public_path__ + "img/sld_scb_34_t1_b1_green.2e881b9d.svg";